import React, { useEffect, useContext } from 'react'
import './notiDropdown.scss'
import { connect } from 'react-redux'
import NotiItem from '../notiItem/notiItem';
import { updateNoti, getNotis, setEndOfNotis } from '../../../../redux/notifications/notifications-actions';
import { AuthContext } from '../../../context/auth-context';
import useHttpClient from '../../../hooks/useHttpClient';
import { setAlert } from '../../../../redux/alert/alert-actions';


const NotiDropdown = props => {

  const auth = useContext(AuthContext);

  const userId = auth.user._id;

  const {error, sendRequest, isLoading} = useHttpClient();

  const fetch = async (number) => {
    
    try {

      let responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/n/notis/${number}`,
      'GET', null, { Authorization: 'Bearer ' + auth.token });
      
      number === 0 ? (props.getNotis(responseData.updatedNotiList)) :
      (props.updateNoti(responseData.updatedNotiList))

      if (responseData.updatedNotiList.length < 40) {
        props.setEndOfNotis();
      }
      

    } catch (err) {
      
    }
  }

  useEffect(() => {
    fetch(0);
  }, [userId]);

  error && props.setAlert(error, 'Error');

  return (
    <div className='noti-dropdown'>
      <div className='noti-dropdown__header' >
        <h2>All Notifications</h2>
      </div>
      <div className='noti-items'> 
      {
        props.notisList.length > 0 
        &&
        (props.notisList.map(item => <NotiItem key={item._id} noti={item}/>)) 
      } 
        <NotiItem noti={{notiType: 'default'}}
        getUpdateNoti={() => fetch(props.notisList.length)}
        isLoading={isLoading} notiLength={props.notisList.length} />
      </div>
    </div>
  )
};


const mapStateToProps = state => ({
  notisList: state.notifications.notisList,
  error: state.notifications.error,
});

export default connect(mapStateToProps, { updateNoti, setAlert, getNotis, setEndOfNotis })(NotiDropdown);